"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const get_1 = __importDefault(require("lodash/get"));
const ChartContext_1 = require("../../context/ChartContext");
const PreferencesContext_1 = require("../../context/PreferencesContext");
const SVGGroup_1 = require("../../elements/SVGGroup");
const useSpectrum_1 = __importDefault(require("../../hooks/useSpectrum"));
const formatNumber_1 = require("../../utility/formatNumber");
const styles = {
    label: {
        fontSize: '11px',
        fill: 'black',
        fontWeight: 'bold',
    },
    value: {
        fontSize: '12px',
        fill: 'black',
    },
    colorIndicator: {
        width: '10px',
        height: '2px',
    },
};
function SpectrumInfoBlock() {
    const { margin } = (0, ChartContext_1.useChartData)();
    const spectrum = (0, useSpectrum_1.default)();
    const { current: { infoBlock: { visible, fields }, }, } = (0, PreferencesContext_1.usePreferences)();
    if (!visible || !spectrum)
        return null;
    return ((0, jsx_runtime_1.jsx)("g", { className: "spectra-info-block", transform: `translate(${margin.left + 5} ${margin.top})`, children: fields
            .filter((field) => field.visible)
            .map((field, index) => {
            const value = (0, get_1.default)(spectrum, field.jpath, '');
            return ((0, jsx_runtime_1.jsxs)(SVGGroup_1.SVGGroup, { transform: `translate(0,${20 * (index + 1)})`, space: 5, children: [(0, jsx_runtime_1.jsxs)("text", { alignmentBaseline: "middle", style: styles.label, children: [field.label, " :"] }), (0, jsx_runtime_1.jsx)("text", { alignmentBaseline: "middle", style: styles.value, children: field?.format && typeof value === 'number'
                            ? (0, formatNumber_1.formatNumber)(value, field.format)
                            : value })] }, field.jpath + field.label));
        }) }));
}
exports.default = SpectrumInfoBlock;
